export default "__VITE_ASSET__79qR_SSL__"